import * as React from 'react';
import { getRange, roundTo } from '../util';
import { DEFAULT_SIZE, DEFAULT_COLOR } from '../types';
import { Child, StyledForldingCircle } from './styles';
const ForldingCircle = ({ size = DEFAULT_SIZE, color = DEFAULT_COLOR, className, }) => {
    const count = 12;
    const range = 1.2;
    const circles = getRange(count).map(v => (React.createElement(Child, { key: v, rotate: roundTo((360 / count) * v, 1), delay: roundTo(range - (range / count) * v, 2) })));
    return (React.createElement(StyledForldingCircle, { className: className, size: size, color: color }, circles));
};
export default ForldingCircle;
//# sourceMappingURL=index.js.map